import React from 'react';
import { motion } from 'framer-motion';
import BounceCards from './BounceCards';

const Projects = () => {
  const projects = [
    {
      title: "RM Webworks",
      image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800&q=80",
      url: "/"
    },
    {
      title: "Veloura",
      image: "/veloura_hero.png", // Copied from Veloura assets to public
      url: "/veloura"
    },
    {
      title: "Core Culture",
      image: "https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=800&q=80",
      url: "/coreculture"
    }
  ];

  return (
    <section className="projects-section" id="projects">
      <div className="projects-container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.8 }}
        >
          OUR WORK
        </motion.h2>
        <motion.p 
          className="section-subtitle"
          initial={{ opacity: 0, y: -10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Click any project to explore it live
        </motion.p>
        
        <motion.div 
          className="bounce-cards-wrapper"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <BounceCards 
            projects={projects}
            containerWidth={600}
            containerHeight={500}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default Projects;
